// function because "utahHeader" window variable doesn't exist immediately
export default () => ({});
